import React from "react";
import { useTranslation } from "react-i18next";

//Style
import "./InfoOilAndGasSection.css";

const InfoOilAndGasSection = ({ info }) => {
  const { t } = useTranslation();

  return (
    <section className="info-oag-section">
      <div className="title-container">
        <span className="deco-title"></span>
        <h1 className="oag-title">Oil & Gas</h1>
        <img
          style={{ width: "2.5rem" }}
          className="title-icon"
          src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/title-icon-1.webp"
          alt=""
        />
      </div>
      <div className="info-oag-supercontainer">
        <div className="info-oag-container border-line">
          <div className="info-oag-txt-container">
            <p className="oag-subtitle">
              {t("oil_and_gas_page.info_section.list_info.title")}
            </p>
            <ul>
              <li>
                {t(
                  "oil_and_gas_page.info_section.list_info.list_elms.list_text_1"
                )}
              </li>
              <li>
                {" "}
                {t(
                  "oil_and_gas_page.info_section.list_info.list_elms.list_text_2"
                )}
              </li>
              <li>
                {" "}
                {t(
                  "oil_and_gas_page.info_section.list_info.list_elms.list_text_3"
                )}
              </li>
              <li>
                {" "}
                {t(
                  "oil_and_gas_page.info_section.list_info.list_elms.list_text_4"
                )}
              </li>
              <li>
                {" "}
                {t(
                  "oil_and_gas_page.info_section.list_info.list_elms.list_text_5"
                )}
              </li>
              <li>
                {" "}
                {t(
                  "oil_and_gas_page.info_section.list_info.list_elms.list_text_6"
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoOilAndGasSection;
